<script>
    import { createEventDispatcher } from "svelte";
    import { appstates } from "../../stores/app-state";
    import Button from "./button.component.svelte";

    const dispatch = createEventDispatcher();

    const handleNext = () => {
        dispatch('navigation-next');
    }


    export let nextEnable = false;

    $: nextEnableCalc = nextEnable && appstates.hasNext();
</script>

<div class="navigation-buttons">
    <Button on:click={ () => appstates.previous() } disabled={! appstates.hasPrevious() } className="secondary" > Précédent </Button>
    <Button on:click={ handleNext } disabled={! nextEnableCalc} > Suivant </Button>
</div>


<style>
    .navigation-buttons {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
</style>